import styles from '@web/components/phone-frame/styles.module.css'
import { useWideDesktopLayout } from '@web/hooks/ui/use-wide-desktop-layout'
import { isElectron } from '@web/libs/electron/platform'
import type { PropsWithChildren } from 'react'

export const PHONE_FRAME_SCREEN_ID = 'web-phone-frame-screen'

// Мобильный контейнер web-приложения: рамка телефона по центру, на широких экранах — с полями.
export function PhoneFrame({ children }: PropsWithChildren) {
  const isWideDesktop = useWideDesktopLayout()

  return (
    <div className={styles.outer} data-electron-shell={isElectron() ? '' : undefined}>
      <div className={isWideDesktop ? `${styles.shell} ${styles.shellWide}` : styles.shell}>
        <div className={styles.frame} id={PHONE_FRAME_SCREEN_ID}>
          <div className={styles.appShell}>{children}</div>
        </div>
      </div>
    </div>
  )
}

export function getPhoneFramePortalElement(): HTMLElement | undefined {
  if (typeof document === 'undefined') return undefined

  return document.getElementById(PHONE_FRAME_SCREEN_ID) ?? undefined
}
